import React from 'react';
import '../styles/RadioButton.css';

export default function RadioButton(props) {
  return (
    <div className="radio-option-wrapper">
      <label className="radio-option-label" htmlFor={`radio-${props.name}-${props.num}`}>
        <input 
          className="radio-option-input" 
          type="radio" 
          name={props.name} 
          id={`radio-${props.name}-${props.num}`} 
          value={props.num}  // ✅ FIXED: Changed from `option${props.num}` to just props.num
          onChange={props.handleOptionChange}
          checked={props.checked}  // ✅ ADDED: Support for checked prop
          required={props.required}
        />
        <span className="radio-custom-button"></span>
        <span className="radio-option-text">{props.option}</span>
      </label>
    </div>
  );
}